import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { SalesforceError } from '../salesforce-data.model';

@Injectable()
export class SalesforceErrorService {
  private _onErrorSubject: BehaviorSubject<SalesforceError> = new BehaviorSubject({visible: false, chatId: ''});
  public readonly onError: Observable<SalesforceError> = this._onErrorSubject.asObservable();

  public notifyError(chatId: string, message?: string) {
    this._notifyStateChanged({
      chatId,
      visible: true,
      message
    });
  }

  public clearError(chatId: string): void {
    this._notifyStateChanged({
      chatId,
      visible: false
    });
  }

  private _notifyStateChanged(newError: SalesforceError): void {
    this._onErrorSubject.next(newError);
  }
}
